import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import type { InvoiceLang } from 'fakturnia-shared';

export interface SelectLanguageDialogData {
  title?: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule],
  selector: 'app-select-language-dialog',
  templateUrl: './select-language-dialog.component.html',
  styleUrls: ['./select-language-dialog.component.scss']
})
export class SelectLanguageDialogComponent {

  public title: string;

  public languages: { code: InvoiceLang; label: string; flag: string }[] = [
    { code: 'pl', label: 'Polski', flag: '🇵🇱' },
    { code: 'en', label: 'Angielski', flag: '🇬🇧' },
    { code: 'de', label: 'Niemiecki', flag: '🇩🇪' },
  ];

  public selectedLang: InvoiceLang = 'pl';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectLanguageDialogData | null,
    private _dialogRef: MatDialogRef<SelectLanguageDialogComponent>
  ) {
    this.title = data?.title || 'Wybierz język dokumentu';
  }

  select(lang: InvoiceLang): void {
    this.selectedLang = lang;
  }

  confirm(): void {
    this._dialogRef.close(this.selectedLang);
  }

  close(): void {
    this._dialogRef.close(undefined);
  }
}
